export const CARRIERS_ERROR = 'CARRIERS_ERROR';
export const CARRIERS_SUCCESS = 'CARRIERS_SUCCESS';
export const CARRIERS_REQUEST = 'CARRIERS_REQUEST';

